import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faRobot, faSparkles } from '@fortawesome/pro-solid-svg-icons';

/**
 * FontAwesome 아이콘 정의를 TinyMCE에서 사용할 수 있는 SVG 문자열로 변환
 */
function fontAwesomeToSvg(iconDefinition: IconDefinition, size: number = 24): string {
  const [width, height, , , svgPath] = iconDefinition.icon;
  
  return `<svg width="${size}" height="${size}" viewBox="0 0 ${width} ${height}"><path d="${svgPath}"/></svg>`;
}

/**
 * TinyMCE에 FontAwesome 아이콘들을 등록
 * TinyMCE가 로드된 후에 호출해야 합니다
 */
export function registerFontAwesomeIcons() {
  if (typeof window !== 'undefined' && (window as any).tinymce) {
    const tinymce = (window as any).tinymce;
    
    // FontAwesome 아이콘들을 SVG로 변환해서 등록 (14px 크기)
    const fontAwesomeIcons = {
      'sparkles': fontAwesomeToSvg(faSparkles, 14),
      'ai-improve-fa': fontAwesomeToSvg(faRobot, 14), // 기존 CSS 버전과 구분
    };

    // 기존 stb 아이콘 팩에 추가
    if (tinymce.IconManager) {
      const existingIcons = tinymce.IconManager.get('stb')?.icons || {};
      
      tinymce.IconManager.add('stb', {
        icons: {
          ...existingIcons,
          ...fontAwesomeIcons
        }
      });
    }
  }
}

/**
 * 새로운 FontAwesome 아이콘을 동적으로 추가
 */
export function addFontAwesomeIcon(name: string, iconDefinition: IconDefinition) {
  if (typeof window !== 'undefined' && (window as any).tinymce) {
    const tinymce = (window as any).tinymce;
    
    if (tinymce.IconManager) {
      const existingIcons = tinymce.IconManager.get('stb')?.icons || {};
      
      tinymce.IconManager.add('stb', {
        icons: {
          ...existingIcons,
          [name]: fontAwesomeToSvg(iconDefinition)
        }
      });
    }
  }
}